// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-add-button[data-v-6ca3805a]{width:var(--btn-width);height:var(--btn-height);background-color:#fff;border:1px solid #e0e0e0;border-radius:5px;display:grid;justify-content:center;justify-items:center;align-content:space-evenly}.custom-add-button--icon[data-v-6ca3805a]{width:35px;height:35px;color:var(--color)}.custom-add-button--text[data-v-6ca3805a]{color:var(--color)}.custom-add-button[data-v-6ca3805a]:hover{cursor:pointer}", ""]);
// Exports
module.exports = exports;
